const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/dashboard/reports.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/pro/dashboard/reports')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

// ─── Types ────────────────────────────────────────────────────────────────────

type Period = 'day' | 'week' | 'month' | 'year';
interface AnalyticsSummary {
  totalBookings: number;
  revenue: number;
  completionRate: number;
  avgBookingValue: number;
}
interface RevenueTrendPoint {
  label: string;
  revenue: number;
}
interface BookingStatusData {
  name: string;
  value: number;
  fill: string;
}
interface ServiceTypeData {
  name: string;
  count: number;
  fill: string;
}
interface BusiestHourData {
  hour: string;
  count: number;
}
interface StaffPerformance {
  name: string;
  bookingsCompleted: number;
  completionRate: number;
}

// ─── Component ────────────────────────────────────────────────────────────────